module.exports = __webpack_public_path__ + "static/media/shoppingCartWhite.087ac8d6.svg";